// News Block View Component
// Read-only view of news stories for public portal pages
import React from 'react';

const NewsBlockView = ({ content }) => {
  if (!content?.stories || content.stories.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 h-full">
      {content.stories.map((story) => (
        <div key={story.id} className="bg-white dark:bg-gray-700 rounded-lg shadow-sm overflow-hidden">
          {story.photoUrl && (
            <img
              src={story.photoUrl}
              alt={story.header}
              className="w-full h-32 object-cover"
            />
          )}
          <div className="p-4">
            <h4 className="font-semibold text-gray-900 dark:text-white mb-2">
              {story.header}
            </h4>
            <div
              className="text-sm text-gray-600 dark:text-gray-300 prose prose-sm"
              dangerouslySetInnerHTML={{ __html: story.body }}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default NewsBlockView;
